<template>
  <b-form-radio-group
    v-model="selectedCurrency"
    :options="currencyOptions"
    name="radio-inline"
    buttons
    button-variant="outline-info"
    size="sm"
    class="lz-currency-group"
    @change="currChange"></b-form-radio-group>
</template>

<script>
export default {
  name: 'CurrencySelector',
  data() {
    return {
      selectedCurrency: 'gbp',
      currencyOptions: [
        { text: '£', value: 'gbp' },
        { text: '$', value: 'usd' },
        { text: '€', value: 'eur' }
      ]
    }
  },
  computed: {
    Store() {
      return this.$store.getters
    },
    FormData() {
      return this.Store.formData
    },
    currency() {
      return this.FormData.currency
    }
  },
  methods: {
    currChange(value) {
      this.$store.commit('modifyFormData', {
        key: 'currency',
        value
      })
    }
  }
}
</script>

<style>
.lz-currency-group {
  display: inline-flex;
  flex-shrink: 0;
  white-space: nowrap;
}
.lz-currency-group .btn {
  border-radius: 0 !important;
  padding: 0 12px !important;
  line-height: calc(1.4em + 18px) !important;
  font-size: 13px !important;
  font-weight: 600 !important;
}
.lz-currency-group .btn:first-of-type {
  border-top-left-radius: 8px !important;
  border-bottom-left-radius: 8px !important;
}
.lz-currency-group .btn:last-of-type {
  border-top-right-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
}
</style>
